<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/roleList">Roles</a></li>
      <li class="breadcrumb-item active" aria-current="page">Create Role</li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <div class="inner-box">
        <div class="row mt-3">
          <div class="col-md-4">
            <label class="text-black mb-3"><b>Create role </b></label>
            <div class="row">
              <div class="col">
                <div class="required">
            <label class="control-label" for="roleName">Role Name</label>
            <div class="form-group required">
              <input type="text" id="roleName" [ngModelOptions]="{standalone: true}"  [(ngModel)]="roleName" class="form-control" required>
              <div id="statusText1" class="invalid-feedback d-block mb-3" [hidden]="!statusText1">{{statusText1}}</div>
            </div>
          </div>
              </div></div></div>
          <div class="col-md-2"></div>
        </div>
      </div>
    </div>
  </div>
<!--  <div class="row mt-3" *ngFor="let role of groupList">-->
<!--    <div class="col">-->
<!--      <div class="inner-box">-->
<!--        <h2 class="text-black">{{role.groupDescription}}</h2>-->
<!--        <div class="row">-->
<!--          <div class="col-6" *ngFor="let action of role.securityTypes">-->
<!--            <div class="row align-items-center mt-2">-->
<!--              <div class="col-lg-3 col-md-5 col-sm-5">-->
<!--                <div class="onoffswitch1">-->
<!--                  <input type="checkbox" name="onoffswitch1" class="onoffswitch1-checkbox" id="{{action.securityTypeId}}" [ngModelOptions]="{standalone: true}"   [(ngModel)]="action.enabled" (change)="statusChange(action)">-->
<!--                  <label class="onoffswitch1-label" for="{{action.securityTypeId}}">-->
<!--                    <span class="onoffswitch1-inner"></span>-->
<!--                    <span class="onoffswitch1-switch"></span>-->
<!--                  </label>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="col-lg-9 col-md-7 col-sm-7 mb-0" [ngClass]="{'text-dark-orange':action.status==='ACTIVE'}">-->
<!--                <label>{{action.securityName}}</label>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div><br><br>-->
  <div class="row">
    <div class="col-6 px-0 pb-5">
      <div class="d-block mt-2" *ngFor="let role of groupList | slice:0: sliceUPto(groupList?.length)">
        <div class="col">
          <div class="inner-box">
            <h2 class="text-black">{{role.groupDescription}}</h2>
            <hr class="mt-1 mb-2">
            <div class="row align-items-center" *ngIf="['outbound_orders','inventory','work_orders','inbound_orders'].indexOf(role.groupCode)>-1">
              <div class="col-lg-3 col-md-5 col-sm-5  text-center">
                <!--                    <div class="d-inline-block w-38">{{role.enableAll?'ON':'OFF'}}</div>-->
                <div class="toggle-2">
                  <input type="checkbox" name="onoffswitch1" id="{{role?.groupId}}" class="custom-control-input" [(ngModel)]="role.enableAll" [ngModelOptions]="{standalone: true}" (change)="allStatusChange(role)" class="checkbox"/>
                  <label for="{{role?.groupId}}" class="toggle">
                    <span>ON</span><span>OFF</span>
                  </label>
                </div>
                <!--<div class=" d-inline custom-control custom-switch ">
                  <input type="checkbox" name="onoffswitch1" class="custom-control-input" id="{{role?.groupId}}" [ngModelOptions]="{standalone: true}"   [(ngModel)]="role.enableAll" (change)="allStatusChange(role)">
                  <label class="custom-control-label" for="{{role?.groupId}}">
                  </label>
                </div>-->
              </div>
              <div class="col-lg-9 col-md-7 col-sm-7" [ngClass]="{'text-dark-orange':role.enableAll}">
                <label class="mb-0">Allow all access</label>
              </div>
            </div>
            <hr  class="my-2" *ngIf="['outbound_orders','inventory','work_orders','inbound_orders'].indexOf(role.groupCode)>-1">
            <div class="row">
              <div class="col-12 my-1" *ngFor="let action of role.securityTypes">
                <div class="row align-items-center">
                  <div class="col-lg-3 col-md-5 col-sm-5  text-center">
                    <!--                        <div class="d-inline-block w-38">{{action.enabled?'ON':'OFF'}}</div>-->
                    <div class="toggle-2">
                      <input type="checkbox" name="onoffswitch1"  id="{{action.securityTypeId}}" class="custom-control-input" [(ngModel)]="action.enabled" [ngModelOptions]="{standalone: true}"  (change)="statusChange(action)" class="checkbox"/>
                      <label for="{{action.securityTypeId}}" class="toggle">
                        <span>ON</span><span>OFF</span>
                      </label>
                    </div>
                   <!-- <div class="d-inline custom-control custom-switch">
                      <input type="checkbox" name="onoffswitch1" class="custom-control-input" id="{{action.securityTypeId}}" [ngModelOptions]="{standalone: true}"   [(ngModel)]="action.enabled" (change)="statusChange(action)">
                      <label class="custom-control-label" for="{{action.securityTypeId}}">
                      </label>
                    </div>-->
                    <!--                  <div class="custom-control custom-switch">-->
                    <!--                    <input type="checkbox"  class="custom-control-input" id="{{action.securityTypeId}}"  [ngModelOptions]="{standalone: true}"   [(ngModel)]="action.enabled" (change)="statusChange(action)">-->
                    <!--                    <label class="custom-control-label" for="{{action.securityTypeId}}"> </label>-->
                    <!--                  </div>-->
                  </div>
                  <div class="col-lg-9 col-md-7 col-sm-7" [ngClass]="{'text-dark-orange':action.status==='ACTIVE'}">
                    <label class="mb-0">{{action.securityName}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6 px-0  pb-5">
      <div class="d-block  mt-2" *ngFor="let role of groupList | slice:sliceUPto(groupList?.length):groupList?.length">
        <div class="col">
          <div class="inner-box">
            <h2 class="text-black">{{role.groupDescription}}</h2>
            <hr class="mt-1 mb-2">
            <div class="row align-items-center" *ngIf="['outbound_orders','inventory','work_orders','inbound_orders'].indexOf(role.groupCode)>-1">
              <div class="col-lg-3 col-md-5 col-sm-5  text-center">
                <!--                  <div class="d-inline-block w-38">{{role.enableAll?'ON':'OFF'}}</div>-->
                <div class="d-inline custom-control custom-switch">
                  <input type="checkbox" name="onoffswitch1" class="custom-control-input" id="{{role?.groupId}}" [ngModelOptions]="{standalone: true}"   [(ngModel)]="role.enableAll" (change)="allStatusChange(role)">
                  <label class="custom-control-label" for="{{role?.groupId}}">
                  </label>
                </div>
              </div>
              <div class="col-lg-9 col-md-7 col-sm-7 " [ngClass]="{'text-dark-orange':role.enableAll}">
                <label class="mb-0">Allow all access</label>
              </div>
            </div>
            <hr class="my-2" *ngIf="['outbound_orders','inventory','work_orders','inbound_orders'].indexOf(role.groupCode)>-1">
            <div class="row">
              <div class="col-12  my-1" *ngFor="let action of role.securityTypes">
                <div class="row align-items-center ">
                  <div class="col-lg-3 col-md-5 col-sm-5  text-center">
                    <!--                      <div class="d-inline-block w-38">{{action.enabled?'ON':'OFF'}}</div>-->
                    <div class="toggle-2">
                      <input type="checkbox" name="onoffswitch1"  id="{{action.securityTypeId}}" class="custom-control-input" [(ngModel)]="action.enabled" [ngModelOptions]="{standalone: true}"  (change)="statusChange(action)" class="checkbox"/>
                      <label for="{{action.securityTypeId}}" class="toggle">
                        <span>ON</span><span>OFF</span>
                      </label>
                    </div>
                    <!--<div class="d-inline custom-control custom-switch">
                      <input type="checkbox" name="onoffswitch1" class="custom-control-input" id="{{action.securityTypeId}}" [ngModelOptions]="{standalone: true}"   [(ngModel)]="action.enabled" (change)="statusChange(action)">
                      <label class="custom-control-label" for="{{action.securityTypeId}}">
                      </label>
                    </div>-->
                    <!--                  <div class="custom-control custom-switch">-->
                    <!--                    <input type="checkbox"  class="custom-control-input" id="{{action.securityTypeId}}"  [ngModelOptions]="{standalone: true}"   [(ngModel)]="action.enabled" (change)="statusChange(action)">-->
                    <!--                    <label class="custom-control-label" for="{{action.securityTypeId}}"> </label>-->
                    <!--                  </div>-->
                  </div>
                  <div class="col-lg-9 col-md-7 col-sm-7" [ngClass]="{'text-dark-orange':action.status==='ACTIVE'}">
                    <label class="mb-0">{{action.securityName}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/roleList" class="btn btn-cancel">Cancel</button>
      <button type="submit" (click)="submitRole()" class="btn btn-orange ml-2">Save</button>
    </div>
  </div>
</div>
